export const AMPLITUDE_EVENTS = {
    EVENTS: {
        RM_GAME_LAUNCHED: 'RM Game Launched',
        RM_EXIT_MODAL_VIEWED: 'RM Exit Modal Viewed',
        RM_MORE_INFO_MODAL_VIEWED: 'RM More Info Modal Viewed',
        MODAL_VIEWED: 'Modal Viewed'
    },

    CATEGORIES: {
        REWARDS_MACHINE: 'rewards_machine',
        CASINO: 'casino'
    },

    ACTIONS: {
        CLICKED: 'clicked'
    },

    LABELS: {
        RM_FIRST_TIME_MODAL: 'rm_first_time_modal'
    },

    MODULES: {
        CASINO: 'casino',
        RM_MORE_INFO: 'rm_more_info',
        RM_EXIT_MODAL: 'rm_exit_modal',
        RM_EXIT_RECOMMENDED_GAMES: 'rm_exit_recommended_games',
        RM_EXIT_BONUS_SPINS: 'rm_exit_bonus_spins'
    }
};
